import { render } from "./ModalAttachments.vue?vue&type=template&id=6d61dfab"
import script from "./ModalAttachments.vue?vue&type=script&lang=js"
export * from "./ModalAttachments.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__